  // Function to clean the title text
  function cleanModelFromTitle(text) {
    // Removes " Modell 20xx," (with leading space) for any year 2000–2099
    return text.replace(/\s*Modell\s+20\d{2},?/gi, '');
  }

  // Function to update all relevant elements
  function updateProductTitles() {
    const selectors = [
      'h1.product-title',
      'a.js-prod-link',
      '.js-item-name'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function(el) {
      if (!el) return;
      
      // Use textContent so we don't break any HTML structure
      const original = el.textContent || '';
      const cleaned = cleanModelFromTitle(original);

      if (cleaned !== original) {
        el.textContent = cleaned;
      }
    });
  }

  // Run after initial DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    updateProductTitles();

    // List of custom events on which we want to re-run
    const events = [
      'on:variant:change',
      'on:cart:add',
      'on:line-item:change',
      'on:cart-drawer:after-open',
      'on:quickbuy:after-open'
    ];

    events.forEach(function(evName) {
      document.addEventListener(evName, function() {
        updateProductTitles();
      });
      // In case some events are fired on window instead of document:
      window.addEventListener(evName, function() {
        updateProductTitles();
      });
    });
  });
